<script setup>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";

const store = useStore();

const fullname = ref("");
const username = ref("");
const selected_permissions = ref([]);

const permissions = computed(() => store.getters["users/getPermissions"]);
const loading = computed(() => store.getters["users/isLoadingCreateUser"]);
const message = computed(() => store.getters["users/getMessage"]);

const isFormValid = computed(() => {
  return (
    fullname.value && username.value && selected_permissions.value.length > 0
  );
});

watch(message, (newStatus) => {
  if (newStatus) {
    fullname.value = "";
    username.value = "";
    selected_permissions.value = [];
  }
});

async function save_user() {
  const payload = {
    fullnames: fullname.value,
    username: username.value,
    permissions: selected_permissions.value,
  };
  await store.dispatch("users/saveUser", payload);
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">ADD NEW USER</h3>
        </div>
        <div class="card-body" x-data="user">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="fullname"
                  placeholder="Enter Name"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Username</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="username"
                  placeholder="Enter Username"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div
              v-for="permission in permissions"
              :key="permission.id"
              class="form-check col-md-4 col-sm-6"
            >
              <input
                v-model="selected_permissions"
                class="form-check-input"
                type="checkbox"
                :value="permission.permission"
                :id="permission.permission"
              />
              <label class="form-check-label" :for="permission.id">
                {{ permission.name }}
              </label>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <br />
              <button
                @click="save_user()"
                class="btn btn-primary fixed-width-button"
                :disabled="!isFormValid || loading"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">ADD USER</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fixed-width-button {
  width: 110px;
}
</style>
